import { gql } from '@apollo/client';

const UPDATE_FACILITY_CLINICIAN_CONTACTS_MUTATION = gql`
  mutation updateFacilityClinicianContacts(
    $facilityId: ID!
    $clinicianContacts: [ClinicianContactInput]!
  ) {
    updateFacilityClinicianContacts(
      facilityId: $facilityId
      clinicianContacts: $clinicianContacts
    ) {
      isSuccess
      message
      facility {
        clinicianContacts {
          name
          phone
          email
          description
        }
      }
    }
  }
`;

export default UPDATE_FACILITY_CLINICIAN_CONTACTS_MUTATION;
